module.exports = __webpack_public_path__ + "static/Maggie Niess.64a7c57f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Maggie Niess.jpg
// module id = 1152
// module chunks = 35783957827783